import { useSelector } from "react-redux";
import aioaLogo from "../../Assets/img/all-in-one-accessibility-logo.svg";
import readWriteLogo from "../../Assets/img/ReadWriteMadeSimple-horizontal-logo.svg";
import { StoreProptypes } from "../../PropTypes/StoreProptypes";
import { Link, useSearchParams } from "react-router-dom";


// component to render logo on dashboard
const DashboardLogo = () => {

    // Redux Data
    const { user, websiteList } = useSelector((store: StoreProptypes) => store);

    //Functions
    const [searchParams] = useSearchParams();

    //Get app parameter
    const app = searchParams.get("app");

    const AIOALogo = () => {
        return (
            <>
                {!websiteList ?
                    <Link to="/front/getting-started">
                        <img src={aioaLogo} alt="All in One Accessibility Logo" />
                    </Link>
                    : <img src={aioaLogo} alt="All in One Accessibility Logo" />
                }
            </>
        )
    }

    return (
        <>
            <div className="aioa_dashboard-logo">
                {user ? <>
                    {user.is_extension_user // check if its a read write made simple extension user
                        ? <img src={readWriteLogo} alt="ReadWriteMadeSimple Logo" />
                        : <AIOALogo />
                    }
                </> : <>
                    {(app && app === "readwritemadesimple") ? <img src={readWriteLogo} alt="ReadWriteMadeSimple Logo" />
                        : <AIOALogo />
                    }
                </>}


            </div>
        </>
    )
}

export default DashboardLogo;